export const TranslationsRU = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Бахаса Индонезия',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Тианг Вьет',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
    },
    // BASE
    phrases: {
        order_online: 'Заказать онлайн',
        cart: 'Корзина',
        open_24: '24 часа',
        closed: 'Закрыто',
        free: 'БЕСПЛАТНО',
        something_went_wrong: 'что-то пошло не так',
        try_again: 'Попробуйте еще раз',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Понедельник',
                tuesday: 'Вторник',
                wednesday: 'Среда',
                thursday: 'Четверг',
                friday: 'Пятница',
                saturday: 'Суббота',
                sunday: 'Воскресенье',
            },
        },
        services: {
            pickup: 'Самовывоз',
            delivery: 'Доставка',
            dine_in: 'В заведении',
            table_booking: 'Бронирование столиков',
        },
        payment: {
            method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Кредитная карта',
                paypal: 'PayPal',
                cardconnect: 'Кредитная карта',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Бритва Плата',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'ПОЛИ ПЕЙ',
                ipay88: 'iPay88',
                bambora_apac: 'Бамбора, Азиатско-Тихоокеанский регион',
                pesapal: 'Pesapal',
                ath_movil: 'АТХ Мовиль',
                custom: 'Custom',
                red_dot: 'Красная точка платежа',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Вива кошелек',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'ПОЛИ ПЕЙ',
                ipay88: 'iPay88',
                bambora_apac: 'Бамбора, Азиатско-Тихоокеанский регион',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'АТХ Мовиль',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Бритва Плата',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Красная точка платежа',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Вива кошелек',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Успешно',
                pending: 'В ожидании',
                error: 'Ошибка',
                refunded: 'Возмещено',
                refunding: 'Возврат',
                partial_refunded: 'Частично возмещено',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Удалить',
                drop_here: 'Перетащите сюда свои файлы или нажмите, чтобы выбрать один',
                accepts: 'Принимает файлы {{fileTypes}}',
                errors: {
                    max_files: 'Разрешено максимум {{number}}',
                    max_size: 'Максимальный размер файла {{kilobytes}} КБ.',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'В настоящее время магазин закрыт, и заказ на обед, подлежащий немедленному оформлению, разместить невозможно. Вместо этого вы можете попробовать заказать на более позднюю дату и время.',
            },
            buttons: {
                order: {
                    book_order: 'Забронировать стол / Заказать онлайн',
                    order_online: 'Заказать онлайн',
                    book_table: 'Забронируйте столик',
                    order: 'Заказ',
                    book: 'Бронь',
                    cart: 'Корзина',
                    restart: 'Начать заново',
                    closed: 'Магазин закрыт',
                    not_accepting: 'Не принимаем заказы',
                },
            },
        },
        modals: {
            auth: {
                login: 'Войти',
                register: 'Регистрация',
                register_commence: 'Продолжить',
                register_complete: 'Зарегистрироваться',
                register_confirmation_sent: 'Код подтверждения был отправлен на ваш адрес электронной почты. Пожалуйста, введите его ниже, чтобы продолжить',
                register_confirmation_resent: 'Код подтверждения был отправлен еще раз, проверьте спам или перезапустите процесс.',
                register_restart: 'Начать заново',
                register_resend_code: 'Повторно отправить код',
                register_confirmation_code_subject: 'Код подтверждения электронной почты',
                register_confirmation_code_email: 'Ваш код подтверждения по электронной почте: {{confirmation_code}} (Срок действия истекает через 24 часа).',
                login_placeholder: 'Эл. почта',
                password_placeholder: 'Пароль',
                confirm_password_placeholder: 'Подтвердите пароль',
                confirmation_code_placeholder: 'Код подтверждения электронной почты',
                accept_terms: 'Принять Условия использования',
                accept_terms_view: 'Просмотр',
                login_facebook: 'Войти через Facebook',
                login_google: 'Войти через Google',
                benefits: 'Войдите или создайте учетную запись, чтобы сохранить все ваши заказы.',
                logged_in: 'Успешный вход',
                logged_out: 'Вышел из системы',
                password_reset: {
                    init_button: 'Отправить письмо для сброса пароля',
                    init_success: 'Ссылка для сброса пароля отправлена ​​на вашу электронную почту',
                    complete_button: 'Сбросить пароль',
                    complete_success: 'Пароль успешно сброшен, войдите с новым паролем',
                    forgot_password_text: 'Забыли пароль?',
                    forgot_password_link: 'Сбросить пароль',
                    remember_password_text: 'Помните свой пароль?',
                    remember_password_link: 'Возвращаться',
                    invalid_title: 'Сброс пароля недействителен',
                    invalid_description: 'Эта ссылка для сброса пароля недействительна. Вместо этого запросите новую.',
                    invalid_link: 'Перейти к входу',
                    title: 'Сброс пароля',
                    description: 'Введите новый пароль для вашей учетной записи',
                },
                error_generic: 'Что-то пошло не так, попробуйте еще раз или свяжитесь с нами.',
                error_accept_terms: 'Пожалуйста, примите условия использования',
                error_password_length: 'Минимум 6 символов для пароля',
                error_social: 'Что-то пошло не так, попробуйте еще раз или свяжитесь с нами.',
                error_confirmation_code: 'Неверный код подтверждения',
                error_invalid_code: 'Неверный код подтверждения',
                error_exists: 'Пользователь уже существует',
                error_invalid_email_pass: 'Неверный адрес электронной почты или пароль',
                error_password_no_match: 'Пароли не совпадают друг с другом',
                error_user_not_found: 'Нет пользователя с таким адресом электронной почты',
                error_invalid_email: 'Неверный адрес электронной почты',
                error_invalid_reset_token: 'Неверная ссылка для сброса, запросите другую.',
            },
            booking: {
                form: {
                    name: 'Полное имя',
                    email: 'Адрес электронной почты',
                    phone: 'Номер телефона',
                    number_of_people: 'Количество человек',
                    number_of_people_max: 'Количество человек ({{max_people}} Макс.)',
                    number_of_people_min: 'Количество человек ({{min_people}} мин)',
                    number_of_people_max_min: 'Количество человек (от {{min_people}} до {{max_people}})',
                    notes: 'Примечания/Особые запросы',
                    submit: 'Отправить запрос на бронирование',
                    email_optional: '(необязательно)',
                    date: 'Дата',
                    duration: 'Продолжительность',
                    seating: 'Доступное время',
                    number_of_guests: 'Количество гостей',
                    notes_placeholder: 'Аллергии, повод, предпочтения по местам',
                    reserving: 'Бронирование...',
                    reserve_table: 'Забронировать стол',
                    please_choose_a_date_and_time: 'Выберите дату и время.',
                    invalid_people: 'Количество гостей должно быть от {{min}} до {{max}}.',
                    party_size_max_fallback: 'допустимого максимума',
                    loading_available_times: 'Загрузка доступного времени…',
                    select_a_date_to_see_available_times: 'Выберите дату, чтобы увидеть доступное время.',
                    no_times_available_for_this_date: 'На эту дату нет свободного времени. Выберите другой день.',
                    shift: 'Смена',
                    service_times: 'Часы обслуживания',
                    new_shift: 'Новая смена',
                    time: 'время',
                    times: 'времена',
                    unavailable: 'Недоступно',
                    available: 'Доступно',
                    required_name: 'Введите ваше имя.',
                    required_phone: 'Введите номер телефона.',
                    required_email: 'Введите адрес электронной почты.',
                    invalid_email: 'Введите действительный адрес электронной почты.',
                    required_terms: 'Примите условия перед бронированием.',
                    reservation_is_unavailable: 'Бронирование недоступно.',
                    please_contact_the_restaurant_directly: 'Свяжитесь с рестораном напрямую.',
                    almost_done: 'Почти готово',
                    your_details: 'Ваши данные',
                    tell_us_who_s_coming: 'Сообщите, кто придёт, чтобы мы могли подтвердить бронирование.',
                    book_your_table: 'Забронируйте стол',
                    choose_a_time_that_works_for_you: 'Выберите удобное время.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Отправьте заявку на бронирование, а ресторан позаботится об остальном.',
                    select_date: 'Выберите дату',
                    standard: 'Стандарт',
                    minutes: 'минут',
                    next: 'Далее →',
                    back: '← Назад',
                    accept_terms: 'Я принимаю условия и положения.',
                    info_1: 'Вы получите уведомление по электронной почте, когда ваше бронирование будет принято или отклонено.',
                },
                errors: {
                    not_found: 'Бронирование не существует. Возможно, оно было удалено',
                    generic: 'Что-то пошло не так, обновите страницу или свяжитесь с нами',
                    something_went_wrong: 'Что-то пошло не так',
                    accept_terms: 'Пожалуйста, примите условия использования',
                    required_phone: 'Пожалуйста, введите свой номер телефона',
                    required_email: 'Пожалуйста, введите свой адрес электронной почты',
                    required_zip: 'Пожалуйста, введите почтовый индекс для выставления счетов',
                    required_name: 'Пожалуйста, введите свое имя',
                    invalid_email: 'Пожалуйста, введите действительный адрес электронной почты',
                    invalid_phone: 'Пожалуйста, введите действительный номер телефона',
                    invalid_people: 'Неверное количество человек',
                    missing_custom_fields: 'Пожалуйста, заполните все обязательные поля.',
                    booking_capacity_threshold: 'На это время мест нет. Выберите другое время.',
                    slot_unavailable: 'Для такого количества гостей мест нет. Выберите другое время.',
                    booking_date_paused: 'Бронирование на эту дату приостановлено. Выберите другой день.',
                    invalid_table_assignment: 'Эти столы не вмещают вашу компанию. Выберите другое время.',
                    exceeded_order_limit: 'Слишком много заявок на бронирование. Повторите попытку позже.',
                    validation_failed_recaptcha_v3: 'Обнаружен необычный трафик. Вы используете VPN? Пройдите проверку выше и повторите попытку.',
                    validation_failed_recaptcha_v2: 'Не удалось начать бронирование. Повторите попытку или используйте другой способ. Если вы используете VPN, сначала отключите его.',
                    booking_already_exists: 'Эта бронь уже отправлена. Проверьте почту или откройте ссылку на бронирование.',
                    invalid_party_size: 'Выберите допустимое количество гостей.',
                    invalid_request: 'Недопустимый запрос. Обновите страницу и повторите попытку.',
                    table_booking_unavailable: 'Бронирование столов недоступно.',
                },
            },
            cart: {
                title: 'Корзина',
                proceed_to_checkout: 'Перейти к оформлению заказа',
                edit_dish: 'Редактировать',
                remove_dish: 'Удалить',
                no_items_1: 'В корзине нет товаров',
                no_items_2: 'Сначала добавьте немного, чтобы продолжить',
                free_delivery_notice: 'Бесплатная доставка на сумму свыше {{value, currency}}.',
                errors: {
                    min_order_promo: 'Минимальная стоимость корзины {{value, currency}}, необходимая для применения данной акции.',
                    min_order_delivery: 'Минимальная стоимость корзины {{value, currency}} для доставки',
                },
                promo: {
                    heading: 'Промо-код',
                    placeholder: 'Введите промокод',
                    add: 'Добавить код',
                    title: 'Промо {{name}} добавлено в корзину',
                    fixed_discount: '{{value, currency}} Выкл.',
                    percent_discount: 'Скидка {{value}}%',
                    added_to_cart: 'Промо добавлено в корзину',
                    errors: {
                        not_found: 'Промо не найдено',
                        disabled: 'Промо отключено',
                        not_available: 'Промо на данный момент недоступно',
                        not_eligible: 'Невозможно применить промокод',
                        not_available_time: 'Акция не распространяется на этот раз',
                        logged_in_only: 'Необходимо войти в систему, чтобы использовать эту акцию',
                        already_used: 'Вы уже использовали эту акцию',
                        invalid: 'Эта акция больше не действительна',
                        invalid_service: 'Эта акция не действительна для выбранной вами услуги.',
                        later_only: 'Действует только для предварительных заказов',
                        now_only: 'Действительно только для заказов, подлежащих немедленной оплате, а не для предварительных заказов.',
                        generic: 'К сожалению... что-то пошло не так и было зарегистрировано',
                        dishes_required_multi: 'Эта акция будет применяться только в том случае, если в вашу корзину будут добавлены определенные товары.',
                        dishes_required_single: "Эта акция применяется только к '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Совет по заказу',
                    placeholder: 'Добавить совет по заказу',
                },
            },
            free_items_promo: {
                title: 'Бесплатные товары',
                usage_confirmation: {
                    question: 'Вы имеете право на бесплатные товары. Хотите их увидеть и добавить?',
                    cancellation: "Нет, я не хочу бесплатные товары",
                    acceptance: 'Да',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Выберите {{number}} объявлений товаров',
                    },
                    single: {
                        description: 'Выберите бесплатный товар',
                    },
                    confirm_button: 'Подтвердить',
                },
            },
            checkout: {
                title: 'Оформление заказа',
                subtitle: 'Подтвердите детали заказа',
                details: {
                    service: 'Услуга',
                    due: 'К сроку',
                    due_now_asap: 'Сейчас / как можно скорее',
                    address: 'Адрес доставки',
                    total: 'Итого',
                    table: 'Стол',
                    store_location: 'Адрес магазина',
                },
                customer: {
                    title: 'Клиент',
                    subtitle: 'Войдите, чтобы сохранить заказ и детали',
                    button: 'Войти',
                    name: 'Полное имя',
                    email: 'Эл. почта',
                    phone: 'Телефон',
                    phone_important: 'Телефон (важно)',
                    notes: 'Примечания к заказу',
                    delivery_notes: 'Инструкции по доставке / Примечания к заказу',
                    optional: 'необязательно',
                },
                payment: {
                    title: 'Способ оплаты',
                    qr_modal_help: 'Используйте мобильное приложение {{app}}, чтобы отсканировать QR-код и завершить оплату этого заказа. После завершения оплаты в вашем мобильном приложении вы можете закрыть это QR-модальное окно. Пожалуйста, не закрывайте это QR-модальное окно, если вы еще не завершили процесс оплаты.',
                    switch_to_app_help: 'При нажатии кнопки ниже автоматически откроется мобильное приложение {{app}} для завершения оплаты этого заказа. После завершения оплаты в вашем мобильном приложении вы можете закрыть это модальное окно. Пожалуйста, не закрывайте это модальное окно, если вы еще не завершили процесс оплаты.',
                    open_app: 'Открытое приложение {{app}}',
                    continue: 'Продолжить',
                    continue_to_payment: 'Продолжить {{method}}',
                    back_to_cart: 'Вернуться в корзину',
                },
                accept_terms: 'Принять Условия использования',
                accept_terms_view: 'Просмотр',
                processing_order: 'Обработка заказа',
                warning: {
                    different_payment_currency: 'Цены в магазине указаны в {{store_currency}}, а способ оплаты — в {{payment_currency}}.',
                    closing_soon: 'Скоро закроется. Для заказа необходима ссылка на {{value}} минут.',
                    closed: 'К сожалению, данный сервис закрыт и заказы не принимаются.',
                    paused: 'К сожалению, данная услуга приостановлена ​​и на данный момент заказы не принимаются.',
                    expired: 'Мы больше не можем выполнить ваш заказ в выбранное вами время. Пожалуйста, выберите более позднюю дату или время',
                },
                errors: {
                    walletly_promo: 'В промо-акции Walletly произошла ошибка. сделай другую акцию!',
                    stripe_generic: 'Ошибка кредитной карты. Попробуйте еще раз или другой метод.',
                    validation_failed: 'В настоящее время этот платеж не может быть принят. Пожалуйста, повторите попытку позже или выберите другой способ оплаты.',
                    validation_failed_recaptcha_v3: 'Внешний необычный трафик. Вы используете VPN? Пожалуйста, выполните задание выше и повторите.',
                    validation_failed_recaptcha_v2: 'Мы не смогли инициировать платеж. Пожалуйста, сформируйте еще раз или используйте другой метод. Если вы используете VPN, сначала отключите его.',
                    stripe_loading_fail: 'Ошибка при загрузке формы оплаты. Повторите попытку.',
                    something_went_wrong: 'Что-то пошло не так',
                    paypal_generic: 'Что-то пошло не так с PayPal. Повторите или выберите другой способ оплаты.',
                    payment_fail: 'Не удалось совершить платеж. Повторите попытку или выберите другой способ оплаты.',
                    payment_cancelled: 'Платеж отменен. Повторите попытку или выберите другой способ оплаты.',
                    payment_error: 'Ошибка при обработке онлайн-платежа. Повторите попытку или выберите другой способ оплаты.',
                    payment_declined: 'Ваш способ оплаты был отклонен',
                    card_declined: "Ваша карта была отклонена, и платеж не удалось обработать",
                    promo_max_uses_exceeded: "Этот промокод достиг лимита использования и больше недоступен.",
                    store_closed: 'Магазин закрыт и больше не принимает заказы',
                    accept_terms: 'Пожалуйста, примите условия использования',
                    required_payment: 'Пожалуйста, выберите способ оплаты',
                    required_phone: 'Пожалуйста, введите свой номер телефона',
                    required_email: 'Пожалуйста, введите свой адрес электронной почты',
                    required_zip: 'Пожалуйста, введите почтовый индекс для выставления счетов',
                    required_name: 'Пожалуйста, введите свое имя',
                    invalid_email: 'Пожалуйста, введите действительный адрес электронной почты',
                    invalid_phone: 'Пожалуйста, введите действительный номер телефона',
                    invalid_cc_number: 'Номер вашей кредитной карты недействителен.',
                    invalid_order_amount: 'Минимальная сумма, необходимая для этого способа оплаты',
                    retry_cc_number: 'Что-то пошло не так. Введите номер своей кредитной карты еще раз и повторите попытку.',
                    closed: 'Магазин закрыт и заказы не принимает.',
                    promo_login_required: 'Необходимо войти в систему, чтобы использовать эту акцию',
                    promo_used: 'Вы уже использовали эту акцию',
                    promo_by_payment_method_not_applicable: 'Акция не распространяется на выбранный способ оплаты.',
                    missing_custom_checkout_fields: 'Пожалуйста, заполните все обязательные поля.',
                    delivery_unavailable: 'Служба доставки в данный момент может быть недоступна. Вместо этого рассмотрите возможность заказа самовывозом.',
                    required_delivery_provider: 'Пожалуйста, выберите услугу доставки.',
                    required_delivery_quotation: 'Срок доставки истек.',
                    exceeded_order_limit: 'На данный момент у нас очень много заказов. Пожалуйста, выберите более позднее время.',
                    exceeded_order_limit_later: 'Мы больше не можем выполнить ваш заказ в выбранное вами время. Пожалуйста, выберите более позднюю дату или время',
                },
                button: {
                    continue: 'Продолжить оплату',
                    place_order: 'Разместить заказ',
                    update_order: 'Обновить заказ',
                },
                delivery_estimation: {
                    title: 'Оценка доставки',
                    details: {
                        provider: 'Поставщик доставки',
                        estimated_fee: 'Ориентировочная плата',
                        estimated_total_fee: 'Общая стоимость доставки',
                        estimated_discount_fee: 'Скидка на стоимость доставки',
                        previous_estimated_fee: 'Предыдущая ориентировочная стоимость',
                        tips: 'Чаевые',
                        estimated_delivery_time: 'Расчетное время доставки',
                        uber_new_estimation: 'Запросить новую оценку',
                        uber_new_estimation_success: 'Применена новая оценка доставки Uber.',
                        uber_estimation_expired: 'Срок доставки истек',
                        uber_price: 'Мы держим цену Uber',
                        uber_need_time: 'мне нужно больше времени',
                        lalamove_price: 'Мы удерживаем стоимость доставки Lalamove.',
                        lalamove_new_estimation_success: 'Применена новая оценка доставки Lalalmove.',
                        lalamove_estimation_expired: 'Срок доставки истек',
                        lalamove_need_time: 'мне нужно больше времени',
                        lalamove_new_estimation: 'Запросить новую оценку',
                    },
                    quotation_error: 'Что-то пошло не так при расчете примерной стоимости доставки.',
                },
            },
            customer: {
                age_v: {
                    title: 'Проверка возраста',
                    required_for_items: 'Требуется для заказа определенных товаров',
                    min_age: 'Минимальный возраст: {{age}} лет',
                    est_time: 'Примерное время проверки: {{time}} часов.',
                    upload_description: 'Загрузите свой идентификатор ниже для проверки. После проверки вы получите уведомление по электронной почте. Загрузите до 2 изображений максимальным размером 2 МБ каждое.',
                    pending_description_1: 'Спасибо за подачу документов. Вы будете уведомлены по электронной почте, когда ваша кандидатура будет одобрена',
                    pending_description_2: 'Обновите страницу, чтобы обновить статус проверки. Примерное время проверки — {{time}} часов.',
                    approved_description: 'Ваша учетная запись подтверждена, и вы можете делать заказы из ограниченного меню.',
                    rejected_description: 'Ваше удостоверение личности было отклонено. Если вы хотите попробовать еще раз, пожалуйста, повторно загрузите свой идентификатор.',
                    upload: 'Загрузить',
                    reupload: 'Повторно загрузить документы',
                    go_back: 'Возвращаться',
                    view_document: 'Посмотреть документ {{number}}',
                    status: {
                        unverified: 'Не подтверждено',
                        pending: 'Ожидание одобрения',
                        approved: 'Успешно проверено',
                        rejected: 'Отклонено',
                    },
                },
                headings: {
                    sessions: 'Сессии',
                    orders: 'Заказ',
                    spend: 'Траты',
                    order_history: 'История заказов',
                    loyalty: 'Лояльность',
                    loyalty_points: 'Баллы лояльности',
                    added: 'Промо добавлено.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Пожалуйста, выберите любой предмет, прежде чем выкупить!',
                    not_found: 'Промо не найдено!',
                    already_exists: 'Промо уже существует!',
                    try_again: 'Невозможно применить эту сделку. Пожалуйста, попробуйте еще раз!',
                },
            },
            custom_payment: {
                title: '{{name}} Форма оплаты',
                description: 'Вы перешли на нашу онлайн-форму оплаты. Пожалуйста, заполните поля ниже, чтобы произвести оплату. Если сумма не будет введена, ваши данные будут сохранены, но с вас не будет списана плата.',
                disabled: 'Эта страница онлайн-платежей настроена неправильно. Пожалуйста, свяжитесь с владельцем сайта для устранения проблемы.',
                success: 'Ваш платеж был успешно обработан, и ваши данные сохранены. Спасибо',
                back: 'Вернуться домой',
                fields: {
                    name: 'Полное имя',
                    email: 'Адрес электронной почты',
                    reference: 'Оплата Реф.',
                    amount: 'Сумма ($)',
                    name_on_card: 'Имя на карте',
                    submit: 'Отправить платеж',
                },
                warning: {
                    currency: 'Примечание. Сумма платежа в {{actual}}, а не в {{default}}.',
                },
                errors: {
                    generic: 'Что-то пошло не так, попробуйте еще раз или свяжитесь с нами.',
                    stripe_generic: 'Ошибка кредитной карты. Обновите страницу и повторите попытку.',
                    payment_fail: 'Не удалось совершить платеж. Повторите попытку или выберите другой способ оплаты.',
                    payment_cancelled: 'Платеж отменен. Повторите попытку или выберите другой способ оплаты.',
                    payment_error: 'Ошибка при обработке онлайн-платежа. Повторите попытку или выберите другой способ оплаты.',
                    payment_declined: 'Ваш способ оплаты был отклонен',
                    card_declined: "Ваша карта была отклонена, и платеж не удалось обработать",
                    promo_max_uses_exceeded: "Этот промокод достиг лимита использования и больше недоступен.",
                },
            },
            dish: {
                add: 'Добавить в корзину',
                edit: 'Обновить элемент',
                notes: 'Особые инструкции...',
                ingredients: {
                    title: 'Ингредиенты',
                    uncheck_remove: 'Снимите флажок, чтобы удалить',
                },
                ingredients_title: 'Ингредиенты',
                combo: {
                    choose_dish: 'Выберите предмет',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Выберите один (обязательно)',
                        select_one_optional: 'Выберите один (необязательно)',
                        select_between: 'Выберите между {{min}} – {{max}} (обязательно)',
                        select_at_least: 'Выберите хотя бы {{qty}} (обязательно)',
                        select_up_to: 'Выберите до {{qty}} (необязательно)',
                        select_multiple_optional: 'Выберите несколько (необязательно)',
                        select_multiple: 'Выберите несколько (обязательно)',
                        free_amount: 'Первый {{qty}} бесплатно / {{selected}} выбрано',
                    },
                    points: {
                        none_consumed: 'Вы можете бесплатно выбрать максимум {{maxFree}} вариантов.',
                        less_than_total_points: 'Вы можете выбрать больше опций бесплатно',
                        greather_than_total_points: 'Вы можете выбрать больше опций за дополнительную плату',
                    },
                },
                error: 'Пожалуйста, исправьте все варианты, отмеченные красным.',
                added_to_cart: 'Товар добавлен в корзину',
            },
            map: {
                zone_fee: 'Стоимость доставки',
                view_in_google: 'Посмотреть на Google Картах',
            },
            portal_go_back: {
                title: 'Вернуться к поиску ресторана?',
                description: 'Любые товары в вашей корзине будут потеряны.',
                cancel: 'Отмена',
                proceed: 'Возвращаться',
            },
            order: {
                config: {
                    services: {
                        title: 'Выберите услугу',
                        table_booking: 'Книжный стол',
                    },
                    address_custom: {
                        input_placeholder: 'Введите свой адрес',
                    },
                    address: {
                        input_placeholder: 'Найдите свой адрес доставки',
                        extras_placeholder: 'Номер квартиры, название здания, инструкции по доставке и т. д.',
                        search_placeholder: 'Найдите свой адрес',
                        search_input_placeholder: 'Введите для поиска',
                        no_address_found: 'Адреса не найдены. Попробуйте ввести более 5 символов',
                        not_found: 'Адрес доставки не найден или недействителен, попробуйте еще раз.',
                        not_delivering: 'В настоящее время мы не осуществляем доставку по этому адресу',
                        not_in_range: 'Ваш адрес находится вне диапазона местоположения нашего магазина.',
                        not_in_zone: 'Ваш адрес не входит в активную зону доставки',
                        no_number: 'В вашем адресе должен быть номер улицы.',
                        location_permission: 'Разрешить этому веб-сайту доступ к вашему текущему местоположению?',
                        location_permission_warning: "Не удается получить доступ к вашему текущему местоположению. Пожалуйста, включите службы геолокации на вашем устройстве и в браузере. Вот несколько справочных материалов:",
                        pick_location: 'Выберите свое местоположение',
                        pick_location_help_text: 'Перетащите маркер, чтобы выбрать местоположение на карте.',
                        use_current_location: 'Использовать текущее местоположение',
                        locate_on_map: 'Найти на карте',
                    },
                    datetime: {
                        title: 'Когда вы хотите получить свой заказ',
                        due_now: 'Сейчас',
                        due_later: 'Позже',
                        service_not_available: 'К сожалению, в настоящее время мы не принимаем заказы на {{service}}.',
                        currently_closed: '{{service}} в настоящее время закрыто, но вы можете заказать его позже',
                        due_unavailable: 'Недоступно',
                        due_closed: 'Закрыто',
                        select_date: 'Выберите дату',
                        select_time: 'Выберите время',
                        select_order_date: 'Выберите дату заказа',
                        select_order_time: 'Выберите время заказа',
                        select_order_date_time: 'Выберите дату/время вашего заказа',
                        select_booking_date: 'Выберите дату бронирования',
                        select_booking_time: 'Выберите время бронирования',
                        no_times_available: 'Нет времени на выбор',
                        date_today: '(Сегодня)',
                        date_closed: '(Закрыто)',
                        date_bookings_paused: '(Бронирование приостановлено)',
                        time_slot_closed: 'Закрыто',
                    },
                    number_of_people: {
                        placeholder: 'Количество человек',
                    },
                    table: {
                        select: 'Выбрать таблицу',
                        select_popup_title: 'Выберите свой стол',
                        password: 'Пароль таблицы',
                        password_warning: 'Введите пароль вашего стола, чтобы продолжить',
                    },
                    warning: {
                        closed: 'К сожалению, в настоящее время мы закрыты/не принимаем заказы.',
                        not_available: 'Извините, в настоящее время мы не принимаем заказы',
                    },
                    eta: {
                        delivery: 'Расчетное время доставки составляет около {{minutesToCustomer}} минут.',
                        pickup: 'Заказ будет примерно готов через {{minutesToCustomer}} минут.',
                    },
                    start_button: 'Начать заказ',
                },
                history: {
                    invalid: 'Повторный заказ невозможен, поскольку некоторые из заказанных товаров были изменены или больше не доступны.',
                },
                reorder: {
                    title: 'Быстрый повторный заказ',
                    description: 'Легко заказывайте товары из ваших предыдущих заказов',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Заказ не найден, обновите страницу и повторите попытку.',
                    booking_not_found: 'Бронирование не существует. Возможно, оно было удалено',
                    generic: 'Что-то пошло не так, обновите страницу или свяжитесь с нами',
                },
                connection: {
                    connected: 'Обновления в реальном времени',
                    connecting: 'Обновления в режиме реального времени',
                    disconnected: 'Обновления в реальном времени отключены',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Предупреждение',
                    title: 'Выйти',
                    body: 'При выходе из системы будут удалены все товары, добавленные в корзину.',
                    cancel: 'Отмена',
                    proceed: 'Продолжить',
                },
                order_restart: {
                    warning: 'Предупреждение',
                    title: 'Изменить детали заказа',
                    body: 'Изменение деталей заказа приведет к удалению товаров из вашей корзины, поскольку некоторые товары могут стать недоступными.',
                    cancel: 'Отмена',
                    proceed: 'Продолжить',
                },
                order_expired: {
                    subtitle: 'Важно',
                    title: 'Заказ изменен на немедленную оплату',
                    description: 'Время, выбранное для вашего заказа, уже не за горами. Таким образом, ваш заказ был изменен на немедленную оплату / как можно скорее.',
                    button: 'Ок',
                },
                order_expiring: {
                    subtitle: 'Важно',
                    title: 'Срок выполнения заказа скоро истекает',
                    description: 'Ваш заказ должен быть размещен до {{time, timeFromTimestamp}}, в противном случае он станет недействительным.',
                    button: 'Ок',
                },
                location_permission: {
                    cancel: 'Отмена',
                    proceed: 'Продолжить',
                },
            },
            card_payment_authentication: {
                title: 'Аутентификация платежа',
                note: 'Держите это окно открытым до тех пор, пока не завершите процесс аутентификации в своем банке.',
            },
            maps: {
                cancel: 'Отмена',
                use_location: 'Использовать местоположение',
            },
            app_refresh: {
                refresh: 'Обновить',
                title: 'Обновить магазин',
                description: 'В нашем магазине произошло обновление. Пожалуйста, обновите браузер, чтобы получить доступ к самой последней версии. После обновления вам может потребоваться снова открыть корзину, чтобы продолжить процесс оформления заказа.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Гость',
                login: 'Войти',
                login_signup: 'Войти / Зарегистрироваться',
                logout: 'Выйти',
            },
            menus: {
                info: {
                    no_menus: 'На данный момент нет доступных меню',
                    restrictions: 'Ограничения меню',
                    not_available: 'Меню недоступно',
                    unavailable: {
                        times: "Меню недоступно, параметры вашего заказа не соответствуют условиям ниже",
                        services: "Меню недоступно, параметры вашего заказа не соответствуют условиям ниже",
                        hours: 'Меню недоступно, часы вашего заказа не входят в доступные часы этого меню.',
                        pre_order: "Меню недоступно, ваш заказ не соответствует требованиям предзаказа",
                        age: 'Меню недоступно. Чтобы сделать заказ из этого меню, вы должны войти в систему с подтвержденным возрастом аккаунтом.',
                    },
                    services: {
                        title: 'Требования к заказу',
                        pickup: 'Самовывозы',
                        delivery: 'Доставки',
                        dine_in: 'В заведении',
                    },
                    times: {
                        now: 'Никаких предварительных заказов',
                        later: 'Только предзаказы',
                    },
                    hours: {
                        title: 'Доступные часы',
                    },
                    preorder: {
                        title: 'Требования к предварительному заказу',
                        days_in_advance: 'Необходимо заказать за {{days}} дней заранее.',
                        cutoff_time: 'Крайний срок последнего дня в {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Возрастные ограничения',
                        approved: 'Ваша учетная запись подтверждена, и вы можете сделать заказ из этого меню.',
                        rejected: 'Для заказа требуется подтверждение возраста. Создайте учетную запись и загрузите свой идентификатор',
                    },
                },
                search: {
                    title: 'Исследуйте пункты меню',
                    no_result: 'Ничего не вернулось. Попробуйте другой поисковый запрос?',
                    placeholder: 'Что Вы ищете?',
                },
            },
            category: {
                restrictions: 'Ограничения категорий',
                not_available: 'Категория недоступна',
                unavailable: {
                    services: "Категория недоступна, параметры вашего заказа не соответствуют условиям ниже",
                    hours: "Категория недоступна, время вашего заказа вне доступных часов этой категории",
                },
            },
            info: {
                location: {
                    title: 'Местоположение',
                    view_map: 'Посмотреть карту',
                    phone: 'Телефон',
                },
                hours: {
                    title: 'Часы работы',
                    title_special: 'Специальные часы работы',
                },
                services: {
                    title: 'Услуги',
                    notes: 'Примечания',
                    delivery: {
                        ranges: 'Диапазоны доставки',
                        zones: 'Зоны доставки',
                        view_zones: 'Просмотр зон на карте',
                        fee: 'Стоимость доставки',
                        fee_short: 'Сбор',
                        fee_varies: 'Варьируется, показано в корзине',
                        min_order: 'Минимальный заказ',
                        min_order_short: 'Мин. зак.',
                        no_min_order: 'Нет минимального заказа',
                        free_amount: 'Сумма бесплатной доставки',
                    },
                },
            },
            contact: {
                title: 'Связаться с нами',
                name: 'Имя',
                email: 'Эл. почта',
                phone: 'Номер телефона',
                message: 'Введите ваше сообщение...',
                send: 'Отправить сообщение',
                success: 'Ваше сообщение успешно отправлено',
                error: 'Что-то пошло не так, попробуйте еще раз или позже.',
            },
            footer: {
                powered_by: 'Питаться от',
                terms_and_conditions: 'Условия использования',
                privacy: 'политика конфиденциальности',
                cookie: 'Политика использования файлов cookie',
            },
        },
        pages: {
            payment_completed: {
                title: 'Ваш платеж был обработан. Спасибо за ваш заказ!',
                subtitle: 'Информация о заказе была отправлена ​​на ваш адрес электронной почты.',
                back_to_menu: 'Вернуться в меню',
                close_tab: 'Закрыть эту вкладку',
            },
            payment_failed: {
                title: 'К сожалению, при обработке вашего платежа произошла ошибка.',
                subtitle: '',
                back_to_menu: 'Вернуться в меню',
                close_tab: 'Закрыть эту вкладку',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Квитанция о бронировании',
            details: {
                datetime: 'Бронирование для',
                number_of_people: 'Количество людей',
                placed: 'Размещен',
                updated: 'Последнее обновление',
                notes: 'Примечания',
                name: 'Имя',
                email: 'Эл. почта',
                phone: 'Телефон',
                store_address: 'Адрес магазина',
            },
            status_update: {
                title: 'Бронирование {{number}} обновлено',
                body: 'Статус вашего уровня обновлен до {{status}}.',
            },
            email_common: {
                name: 'Имя: {{name}}',
                phone: 'Телефон: {{number}}',
                number_of_people: 'Количество человек: {{number}}',
                date: 'Дата: {{date}}',
                time: 'Время: {{time}}',
                location: 'Местоположение магазина: {{name}}',
                notes: 'Примечания: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Новый заказ столика {{number}} от {{name}}',
                powered_by: 'Создано {{name}}',
                overview: 'Запрос на бронирование нового столика',
                title: 'Новое бронирование для {{name}}',
                subtitle: 'Уровень уровня {{number}}',
                description_confirmed: 'Бронирование было автоматически подтверждено. Вы можете отменить его через панель администратора, и ваш клиент будет уведомлен об этом по электронной почте.',
                description_unconfirmed: 'Пожалуйста, подтвердите или отмените бронирование через панель администратора.',
                url_pre_text: 'Посмотреть и обновить на',
            },
            email_new_booking_customer: {
                subject: 'Запрос на бронирование столика',
                powered_by: 'Создано {{name}}',
                overview: 'Запрос на бронирование нового столика',
                title: 'Спасибо за бронирование',
                subtitle: 'Уровень уровня {{number}}',
                description: '<b>Вы получите еще одно электронное письмо, когда ваше бронирование будет подтверждено или отклонено.</b><br>Пожалуйста, свяжитесь с нами, чтобы внести какие-либо изменения в ваше бронирование. Детали вашего бронирования следующие:',
                url_pre_text: 'Вы можете просмотреть квитанцию ​​о бронировании в режиме реального времени на странице',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Бронирование столика подтверждено',
                subject_unconfirmed: 'Бронирование столика отменено',
                powered_by: 'Создано {{name}}',
                overview: 'Запрос на бронирование столика',
                title_confirmed: 'Бронирование подтверждено',
                title_unconfirmed: 'Бронирование отменено',
                subtitle: 'Уровень уровня {{number}}',
                description_confirmed: 'Мы с нетерпением ждем встречи с вами. Пожалуйста, свяжитесь с нами, чтобы запросить любые изменения в вашем бронировании.',
                description_unconfirmed: 'С сожалением сообщаем Вам, что Ваш запрос на бронирование не был принят. Приносим извинения за причиненные неудобства. Пожалуйста, свяжитесь с нами, если у вас есть какие-либо вопросы',
                url_pre_text: 'Вы можете просмотреть квитанцию ​​о бронировании в режиме реального времени на странице',
            },
            email_status_update_customer: {
                subject: 'Бронирование #{{number}} – {{subjectLabel}}',
                body: 'Ваше бронирование #{{number}} в {{store}} теперь {{status}}.',
            },
            errors: {},
            status_warning: 'Обновите статус этого бронирования в панели администратора на странице бронирования.',
        },
    },
    email_delayed_order: {
        subject: 'Заказ #{{number}} – {{subjectLabel}}',
        header: 'Обновлённое время готовности',
        title: 'Обновлённое время готовности',
        order_number: 'Номер заказа: {{number}}',
        description: 'Ваш заказ будет готов к {{time}}.',
        order_time_updated_to: 'Время вашего заказа обновлено.',
        powered_by: 'Создано {{name}}',
        button_text: 'Отследить заказ',
        subject_label: 'Обновлённое время готовности',
        subject_label_delivery: 'Обновлённое время доставки',
        body_ready: 'Ваш заказ будет готов к {{time}}.',
        body_delivery: 'Ваш заказ будет доставлен к {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Стандартное восточное время. Время готовности',
            est_driver_pickup_time: 'Стандартное восточное время. Время встречи с водителем',
            est_delivery_time: 'Стандартное восточное время. Срок поставки',
            tab_details: 'Детали',
            tab_dishes: 'Позиции',
            future_order: 'Будущий порядок',
            reprint: 'ПОВТОРНАЯ ПЕЧАТЬ',
            details: {
                order_no: 'Заказ №.',
                status: 'Статус',
                placed: 'Размещен',
                due: 'К сроку',
                due_asap: 'Сейчас / как можно скорее',
                last_updated: 'Последнее обновление',
                total: 'Итого',
                type: 'Тип',
                origin: 'Источник',
                table: 'Стол',
                number_of_people: 'Количество человек',
                payment_method: 'Способ оплаты',
                payment_status: 'Статус платежа',
                payment_currency: 'Валюта платежа',
                notes: 'Примечания',
                name: 'Имя',
                email: 'Эл. почта',
                phone: 'Телефон',
                distance: 'Расстояние',
                driving_time: 'Время вождения',
                delivery_zone: 'Зона',
                delivery_address: 'Адрес доставки',
                delivery_provider: 'Поставщик доставки',
                delivery_tracking: 'Отслеживание доставки',
                delivery_return_tracking: 'Отследить возврат',
                delivery_tracking_link: 'Отследить заказ',
                tookan_status: 'Тукан Статус',
                tookan_status_failed_book: 'Не удалось заказать доставку',
                tookan_status_failed_update: 'Не удалось обновить бронирование.',
                tookan_status_success: 'Забронировано на доставку',
                store_address: 'Адрес магазина',
                destination: 'Пункт назначения',
                estimated_arrival_time: 'Расчетное время прибытия',
                delivery_status: 'Статус',
                delivery_track_your_order: 'Отслеживайте свой заказ',
                delivery_text: 'Доставка',
                arrival_date: 'Дата прибытия',
            },
            dishes: {
                headings: {
                    quantity: 'Кол-во',
                    item: 'Позиция',
                    price: 'Цена',
                },
                notes: 'Примечания',
                remove_ingredients: 'Удалить ингредиенты',
            },
            status_update: {
                title: 'Заказ {{number}} обновлен',
                body: 'Статус вашего заказа обновлен до {{status}}.',
            },
            wait_time_update: {
                title: 'Заказ {{number}} обновлен',
                body: 'Срок выполнения вашего заказа обновлен.',
            },
            delivery_update: {
                title: 'Заказ {{number}} обновлен',
                body: 'Ваш заказ забронирован на доставку. См. ссылку для отслеживания в реальном времени',
            },
            payment_status_update: {
                title: 'Заказ {{number}} обновлен',
                body: 'Статус оплаты вашего заказа обновлен.',
            },
            email_new_order_restaurant: {
                subject: 'Новый заказ ({{number}}) — {{name}}',
                powered_by: 'Создано {{name}}',
                overview: 'Уведомление о новом заказе',
                title: 'Новый заказ размещен {{name}}',
                subtitle: 'Номер заказа {{number}}',
                description: 'Просматривайте подробную информацию и обновления через панель администратора.',
                button_text: 'Отследить заказ',
                track_delivery_button_text: 'Отследить доставку',
            },
            email_new_order_customer: {
                subject: 'Квитанция заказа ({{number}})',
                powered_by: 'Создано {{name}}',
                overview: 'Уведомление о новом заказе',
                title: 'Новый заказ размещен {{name}}',
                subtitle: 'Номер заказа {{number}}',
                description: 'Просматривайте подробную информацию и обновления через онлайн-квитанцию ​​в режиме реального времени.',
                button_text: 'Отследить заказ',
                track_delivery_button_text: 'Отследить доставку',
            },
            email_order_completed_by_customer: {
                subject: 'Заказ ({{number}}) выполнен клиентом',
                powered_by: 'Создано {{name}}',
                overview: 'Уведомление о завершении заказа',
                title: 'Заказ завершен {{name}}',
                subtitle: 'Номер заказа {{number}}',
                description: 'Просматривайте детали и обновляйте свой заказ через личный кабинет или с помощью квитанции по адресу',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) вкл. в цене',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Стоимость доставки',
            delivery_fee_offset: 'Скидка на стоимость доставки',
            delivery_fee_total: 'Общая стоимость доставки',
            promo: 'Скидка: {{name}} ({{value, currency}} + скидка {{percent}}%)',
            promo_percent: 'Скидка: {{name}} ({{percent}}%)',
            promo_fixed: 'Скидка: {{name}}',
            promo_none: 'Скидка: {{name}}',
            cart: 'Корзина',
            tip: 'Совет по заказу',
            total: 'Итого',
        },
        status: {
            unconfirmed: 'Не подтвержден',
            awaiting_payment: 'Ожидание оплаты',
            confirmed: 'Подтвержден',
            ready: 'Готов',
            on_route: 'В пути',
            complete: 'Завершен',
            cancelled: 'Отменен',
            seated: 'Размещены',
        },
        searching: {
            lalamove_search_placeholder: 'Поиск заказа по идентификатору доставки Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Недоступно',
                },
            },
            dish: {
                no_stock: 'Распродано',
                not_available: 'Нет в наличии',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Код подтверждения электронной почты',
            register_confirmation_code_email: 'Ваш код подтверждения по электронной почте: {{confirmation_code}} (Срок действия истекает через 24 часа).',
            register_confirmation_code_email_onbehalf: 'Ваш код подтверждения по электронной почте: {{confirmation_code}} (срок действия истекает через 24 часа). Это адрес электронной почты {{email}}.',
        },
    },
};
//# sourceMappingURL=ru.js.map